import { useEffect, useState, useRef } from "react";
import DateComp from "../../../../core/common/dateComponent/DateComp";
import Ribbon from "../../../../core/common/ribbon/ribbon";
import TextField from "../../../../core/common/textFields/TextField";
import { useTableSelection } from "../../../../core/hooks/useTableSelection";
import SidebarAddenda from "./Addenda Wizard/SidebarAddenda";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  useGetAllAddendaQuery,
  useGetSaleInfoByIdQuery,
  useLazyGetAddendaAgreementQuery,
  useLazyGetSaleInfoByIdQuery,
  useLazyGetTeamMembersEmailQuery,
  useSendEmailMutation,
} from "../../../../services/EndPointsApis";
import { usePermission } from "../../../../core/hooks/PermissionHook";
import { constantsPermission } from "../../../../Config/Constants";
import { svgIcons } from "../../../../style/fonts/SvgIcons";
import ModalComponent from "../../../../core/common/modal/ModalComponent";
import AddendaCard from "../PrintOut Tab/download to pdf/AddendaCard";
import RichTextEditor from "../../../../core/common/Rich Text Editor/RichTextEditor";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { customStyles } from "../../../../core/common/Custom Style/CustomStyle";
import Select from "react-select";
import html2pdf from "html2pdf.js";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import TableLoading from "../../../../core/common/loadingComponent/TableLoading";
import FormattedNumber from "../../../../core/common/textFields/FormatNumber";
import MbuReporting from "../../MBU Reporting/MbuReporting";
import { useReactToPrint } from 'react-to-print';

const Addenda = ({
  projectId,
  projectLookups,
  projectByIdData,
  getallActiveUsers,
  refetchApiAfterWizard,
}: any) => {
  //PermissionHook
  const {
    view: viewAddenda,
    edit: editAddenda,
    create: createAddenda,
  } = usePermission(constantsPermission?.moduleId?.addenda);

  const [showAddenda, setShowAddenda] = useState(false);
  const [addendaId, setAddendaId] = useState('');
  const [addendaIdForPdf, setAddendaIdForPdf] = useState(null);
  const [ispdfLoading, setPdfIsLoading] = useState(false);
  const [togglestepperAssignment, setTogglestepperAssignment] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [viewOnly, setViewOnly] = useState(false);
  const [isReviewed, setisReviewed] = useState(false);
  const [isReviewTitle, setisReviewTitle] = useState(false);
  const [isApproved, setisApproved] = useState(false);
  const [jobScopeCheck, setJobScopeCheck] = useState(false)
  const [documentCheck, setDocumentCheck] = useState(false);

  //Get pdf data

  const [getAddendaPdfData, { data: addendaData, isSuccess: isSuccessPdf, isFetching }] = useLazyGetAddendaAgreementQuery();
  //Get Sale Info

  const [triggerSaleInfo, { data: saleInfoData }] = useLazyGetSaleInfoByIdQuery()

  const { data, isLoading, refetch } = useGetAllAddendaQuery({
    ProjectId: projectId,
  });

  const [totalAddendaSaleAmt, setTotalAddendaSaleAmt] = useState({
    addendaAmount: data?.result[0]?.saleAmountAddendaTotal,
    saleAmount: data?.result[0]?.contractSalePrice,
  });

  const [totalAddendaAmt, setTotalAddendaAmt] = useState(0);

  const handleShowstepper = () => {
    setTogglestepperAssignment(true);
    setIsEditing(false);
  };
  const handleEditStepper = (data: any) => {
    setTogglestepperAssignment(true);
    setIsEditing(true);
    setAddendaId(data?.id);
    // handleCheckItem(e,data)
  };
  const handleclosestepper = () => {
    setTogglestepperAssignment(false);
    setIsEditing(false);
    setAddendaId('');
    setViewOnly(false)
    setisReviewed(false)
    setisApproved(false)
    setisReviewTitle(false)
  };

  const mergedData = [
    ...(data?.result?.approvedAndReviewd || []),
    ...(data?.result?.pendingAndVoided || []),
  ];
  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: UserData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleDelete,
  } = useTableSelection(data?.result?.approvedAndReviewd || [], "id");

  const {
    isTableHeadChecked: isTableHeadCheckedPending,
    selectedIndividualCheckboxId: selectedIndividualCheckboxIdPending,
    handleTableHeadChange: handleTableHeadChangePending,
    handleCheckItem: handleCheckItemPending,
    handleRowClick: handleRowClickPending,
    handleDelete: handleDeletePending,
  } = useTableSelection(data?.result?.pendingAndVoided || [], "id");

  const isAnyCheckboxChecked =
    selectedIndividualCheckboxId.length > 0 ||
    selectedIndividualCheckboxIdPending.length > 0;
  const isMoreThanOneChecked =
    selectedIndividualCheckboxId.length > 1 ||
    selectedIndividualCheckboxIdPending.length > 1;
  const totalAddendaApprSaleAmount = data?.result?.approvedAndReviewd?.reduce(
    (sum: any, data: any) => sum + data.saleAmount,
    0
  );
  const totalGrandApprSaleAmount =
    (data?.result?.originalContract?.saleAmount || 0) +
    (totalAddendaApprSaleAmount || 0);

  const totalAddendaApprCostAmount = data?.result?.approvedAndReviewd?.reduce(
    (sum: any, data: any) => sum + data.costAmount,
    0
  );
  const totalGrandApprCostAmount =
    (data?.result?.originalContract?.costAmount || 0) +
    (totalAddendaApprCostAmount || 0);

  const totalAddendaPendSaleAmount = data?.result?.pendingAndVoided?.reduce(
    (sum: any, data: any) => sum + data.saleAmount,
    0
  );
  const totalAddendaPendCostAmount = data?.result?.pendingAndVoided?.reduce(
    (sum: any, data: any) => sum + data.costAmount,
    0
  );

  const totalMarkUpAppr = totalAddendaApprSaleAmount / totalAddendaApprCostAmount
  const grandTotalMarkup = totalGrandApprSaleAmount / totalGrandApprCostAmount
  const totalMarkUpPend = totalAddendaPendSaleAmount / totalAddendaPendCostAmount
  const OrignalContractMarkup = data?.result?.originalContract?.saleAmount / data?.result?.originalContract?.costAmount
  const isAnyApproved = data?.result?.approvedAndReviewd?.some((item: { status: string; }) => item.status === "Reviewed");


  const handleRowClicked = (data: any) => {
    handleRowClick(data);
  };
  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (refetchApiAfterWizard === true) {
      refetch();
    }
  }, [refetchApiAfterWizard]);

  const formatComma = (num: number | string) => {
    if (num === null || num === undefined) return "0.0";
    const numericValue = String(num).replace(/,/g, "");
    if (isNaN(Number(numericValue))) return String(num);
    return Number(numericValue).toLocaleString();
  };

  const projectStatus =
    projectByIdData?.result?.projectStatus === "Complete" ||
    projectByIdData?.result?.projectStatus === "Marked Dead" ||
    projectByIdData?.result?.projectStatus === "Active" ||
    projectByIdData?.result?.projectStatus === "Marked Dead" ||
    projectByIdData?.result?.projectStatus === "Marked For Rehash Follow" ||
    projectByIdData?.result?.projectStatus === "Promoted Lead to SW";

  const initialValues = {
    Subject: "",
    InternalEmailAddresses: [
      {
        id: 0,
        value: "",
      },
    ],
    ExternalEmailAddresses: [""],
    Body: "",
    Attachments: [] as { name: string; data: ArrayBuffer }[],
  };

  const [showModal, setShowModal] = useState(false);
  const [modalTitlePopup, setModalTitlePopup] = useState("");
  const [noteDescription, setNoteDescription] = useState("");

  //email api
  const [sendEmail, { data: sendEmailData, isSuccess, isLoading: isLoadingEmail }] =
    useSendEmailMutation();
  //getTeam Member Email
  const [
    triggerTeamsMember,
    { data: getTeamMembers, isSuccess: isSuccessEmail },
  ] = useLazyGetTeamMembersEmailQuery();

  const [emails, setEmails] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState("");
  const [fileData, setFileData] = useState<File[]>([]);

  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const decodeHtml = (html: any) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      const email = inputValue.trim();

      if (
        isValidEmail(email) &&
        !formik.values.ExternalEmailAddresses.includes(email)
      ) {
        formik.setFieldValue("ExternalEmailAddresses", [
          ...formik.values.ExternalEmailAddresses.filter(
            (email: string) => email !== ""
          ),
          email,
        ]);
        setInputValue("");
      }
    }
  };
  const removeEmail = (email: string) => {
    const filteredEmails = formik.values.ExternalEmailAddresses.filter(
      (e: string) => e !== email
    );
    formik.setFieldValue("ExternalEmailAddresses", filteredEmails);
  };
  const handleClose = () => {
    setShowModal(false);
    formik.resetForm();
  };
  const handleCloseAddenda = () => {
    setShowAddenda(false);
    setisApproved(false)
    setisReviewed(false)
    setisReviewTitle(false)

  };
  const handleShowAddenda = (item: any) => {
    setAddendaIdForPdf(item);
    setShowAddenda(true);
  };

  const handleSave = () => {
    formik.handleSubmit();
  };
  const handleGetTeamMembers = () => {
    triggerTeamsMember({ projectId: projectId });
  };

  const formik = useFormik({
    initialValues,
    // validationSchema: loginSchema,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("Subject", values.Subject);
      formData.append(
        "InternalEmailAddresses",
        values.InternalEmailAddresses.map((item) => item.value).toString()
      );
      formData.append(
        "ExternalEmailAddresses",
        values.ExternalEmailAddresses.toString()
      );
      formData.append("Body", values.Body);
      values.Attachments.forEach(({ name, data }, index) => {
        const fileBlob = new Blob([data], { type: "application/pdf" });
        formData.append(`Attachments`, fileBlob, name);
      });
      try {
        await sendEmail(formData).unwrap();
        toast.success("File uploaded successfully");
        formik.resetForm();
        setShowModal(false);
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    },
  });

  const selectValues = formik.values?.InternalEmailAddresses
    ? formik.values.InternalEmailAddresses.filter(
      (users: { id: number; value: string }) =>
        users.id !== 0 && users.value !== ""
    ).map((users: { id: number; value: string }) => ({
      value: users?.id,
      label: users?.value,
    }))
    : [];

  const handleChange = (newValue: any) => {
    const updatedValues = newValue.map(
      (option: { value: any; label: any }) => ({
        id: option.value,
        value: option.label,
      })
    );

    formik.setFieldValue("InternalEmailAddresses", updatedValues);
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      setFileData(fileArray);
      formik.setFieldValue("Attachments", fileArray);
    }
  };

  useEffect(() => {
    if (getTeamMembers?.result && isSuccessEmail) {
      formik.setFieldValue(
        "InternalEmailAddresses",
        getTeamMembers.result.map((member: any) => {
          return {
            id: member.id,
            value: member.value,
          };
        })
      );
    }
  }, [getTeamMembers?.result, isSuccessEmail]);

  const downloadPDF = async (item: any) => {
    const dynamicFileName = `${item?.addendaNbr || "default"
      }.pdf`;
    const content = document.getElementById("pdf-content");
    if (!content) {
      setPdfIsLoading(false);
      return;
    }
    const options = {
      margin: 0,
      filename: dynamicFileName,
      html2canvas: { scale: 5 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    setPdfIsLoading(true);
    try {
      await html2pdf().set(options).from(content).save();
      setShowAddenda(false);
    } catch (error) {
    } finally {
      setPdfIsLoading(false);
    }
  };

  const handleGeneratePDFAddenda = async (item: any) => {
    const content = document.getElementById("pdf-content");
    if (!content) {
      console.error("Element not found:", "pdf-content");
      return;
    }

    const options = {
      margin: 0,
      filename: `${item?.addendaNbr}.pdf`,
      html2canvas: { scale: 5 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf()
        .set(options)
        .from(content)
        .toPdf()
        .output("blob");
      console.log("PDF Blob created successfully");

      // Convert Blob to ArrayBuffer
      const arrayBuffer = await pdfBlob.arrayBuffer();
      // Update Formik field
      formik.setFieldValue("Attachments", [
        { name: `${item?.addendaNbr}.pdf`, data: arrayBuffer },
      ]);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  const handleEmailAddenda = (item: any) => {
    setModalTitlePopup(`${item.addendaNbr} Email`);
    setShowModal(true);
    setShowAddenda(false);
    handleGeneratePDFAddenda(item);
  };
  const handleViewAddenda = (data: any) => {
    setTogglestepperAssignment(true);
    setIsEditing(true);
    setAddendaId(data?.id);
    setViewOnly(true)
  }
  const handleReviewAddenda = (data: any) => {
    setTogglestepperAssignment(true);
    setIsEditing(true);
    setAddendaId(data?.id);
    setisReviewTitle(true)
    // setisReviewed(true)
  }
  const handleApproveAddenda = (data: any) => {
    setTogglestepperAssignment(true);
    setIsEditing(true);
    setAddendaId(data?.id);
    setisApproved(true)
  }
  const { permissionList } = usePermission(
    constantsPermission?.moduleId?.addenda
  );
  const [isRenderReady, setIsRenderReady] = useState(false);
  const [printKey, setPrintKey] = useState(0);
  const [shouldPrint, setShouldPrint] = useState(false);

  const printRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => {
      setShouldPrint(false);
      setPrintKey(prev => prev + 1);
    },
  } as any);

  const handlePrintWithData = (item: any) => {
    setAddendaIdForPdf(item);
    setShouldPrint(true);
    setIsRenderReady(false);
    getAddendaPdfData({ ProjectId: projectId, AddendaId: item.id });
    triggerSaleInfo({ProjectId: projectId})
  };
  const [addendaDataForPdf, setAddendaDataForPdf] = useState<any>(null);
  const [saleInfoDataForPdf, setSaleInfoDataForPdf] = useState<any>(null);

  useEffect(() => {
    if (addendaData?.result && saleInfoData?.result) {
      setAddendaDataForPdf(addendaData);
      setSaleInfoDataForPdf(saleInfoData);
    }
  }, [addendaData,saleInfoData]);

  useEffect(() => {
    if (shouldPrint && isRenderReady) {
      setTimeout(() => {
        handlePrint();
        setShouldPrint(false);
      }, 150);
    }
  }, [shouldPrint, isRenderReady]);

  return (
    <>
      <ModalComponent
        buttonText="Send"
        modalTitle={modalTitlePopup}
        onClose={handleClose}
        onSave={handleSave}
        isVisible={showModal}
        cancelButton="Cancel"
        saveButton="Send"
      >
        <>
          <div className="row">
            <div className="col-md-12">
              <div className="input-label">
                <TextField
                  label="Subject"
                  required
                  type="text"
                  {...formik.getFieldProps("Subject")}
                />
              </div>
              <div className="col-md-12">
                <div className="d-flex justify-content-between align-items-center">
                  <label>Internal Users</label>
                  <button
                    className="btn btn-primary mb-1 mt-1 fs-11"
                    onClick={handleGetTeamMembers}
                  >
                    Get Team Members
                  </button>
                </div>
                <Select
                  isMulti={true}
                  styles={customStyles}
                  className="select multi-select"
                  options={
                    projectLookups?.result?.ActiveUserEmail?.map(
                      (option: any) => ({
                        label: option?.value,
                        value: option?.id,
                      })
                    ) || []
                  }
                  value={selectValues}
                  onChange={(newValue: any) => handleChange(newValue)}
                />
              </div>
              <div className="col-md-12">
                <div className="d-flex justify-content-between">
                  <label className="input-label">External Users</label>
                </div>
                <div className="email-input-container">
                  <div className="badges-container">
                    {formik.values.ExternalEmailAddresses[0] !== "" ? (
                      formik.values.ExternalEmailAddresses.map(
                        (email: string, index: number) => (
                          <span
                            key={index}
                            className="badge badge-pill badge-primary me-2"
                          >
                            {email}{" "}
                            <button
                              type="button"
                              className="btn-close ms-1"
                              onClick={() => removeEmail(email)}
                            >
                              &times;
                            </button>
                          </span>
                        )
                      )
                    ) : (
                      <span className="text-muted">...</span>
                    )}
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter email and Press enter"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      onKeyDown={handleKeyDown}
                      disabled
                    />
                  </div>
                  {formik.errors.ExternalEmailAddresses && (
                    <div className="text-danger">
                      {formik.errors.ExternalEmailAddresses}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <RichTextEditor
                  value={formik.values.Body}
                  name="Message"
                  onChange={(value: any) => formik.setFieldValue("Body", value)}
                />
              </div>
              <label className="input-label mt-2"> Attachments</label>
              <div className="br-gray p-2 bg-lightGray">
                <p>{formik.values.Attachments[0]?.name}</p>
              </div>
            </div>
          </div>
        </>
      </ModalComponent>
      <ReactTooltip
        id="my-tooltip-1"
        place="top"
        content="Approve Addenda"
        style={{ color: "#B11F28", backgroundColor: '#F8E9EA', zIndex: 999 }}
      />
      <ReactTooltip
        id="my-tooltip-2"
        place="top"
        content="Review Addenda"
        style={{ color: "#B11F28", backgroundColor: '#F8E9EA', zIndex: 999 }}
      />
      <ReactTooltip
        id="my-tooltip-3"
        place="top"
        content="Edit Addenda"
        style={{ color: "#B11F28", backgroundColor: '#F8E9EA', zIndex: 999 }}
      />
      <ReactTooltip
        id="my-tooltip-4"
        place="top"
        content="View Addenda"
        style={{ color: "#B11F28", backgroundColor: '#F8E9EA', zIndex: 999 }}
      />
      <ReactTooltip
        id="my-tooltip-5"
        place="top"
        content="Print Addenda"
        style={{ color: "#B11F28", backgroundColor: '#F8E9EA', zIndex: 999 }}
      />
      {/* <ModalComponent
        modalTitle=""
        isVisible={showAddenda}
        cancelButton="Cancel"
        buttonText2="Send Email"
        // buttonText3="Print"
        onSave2={() => handleEmailAddenda(addendaIdForPdf)}
        onSave3={handlePrint}
        onClose={handleCloseAddenda}
        saveButton={"Print"}
        className="p-2 modal-xl"
        // onSave={() => downloadPDF(addendaIdForPdf)}
        onSave={handlePrint}
      >

      </ModalComponent> */}

      <div style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}>
        {addendaIdForPdf && addendaDataForPdf && (
          <AddendaCard addendaId={addendaIdForPdf} projectId={projectId} printRef={printRef} key={printKey}
            onRenderReady={() => setIsRenderReady(true)} saleInfoDataForPdf={saleInfoDataForPdf}
            addendaData={addendaDataForPdf} />
        )}
      </div>

      <SidebarAddenda
        projectId={projectId}
        totalAddendaSaleAmt={totalAddendaSaleAmt}
        getallActiveUsers={getallActiveUsers}
        projectLookups={projectLookups}
        refetch={refetch}
        togglestepperAssignment={togglestepperAssignment}
        closestepper={handleclosestepper}
        isEditing={isEditing}
        selectedIndividualCheckboxId={selectedIndividualCheckboxId}
        selectedaddendaguid={addendaId}
        selectedIndividualCheckboxIdPending={
          selectedIndividualCheckboxIdPending
        }
        handleDelete={handleDelete}
        viewOnly={viewOnly}
        isReviewed={isReviewed}
        isApproved={isApproved}
        isReviewTitle={isReviewTitle}
      />
      {/* <Ribbon
                buttonText='+Add an Addendum'
                buttonClass='add-popup ribbon-btn'
                columnClass1='col-md-8 col-12'
                columnClass2='col-12 col-md-4'
                onClickbtn={handleShowstepper}
                disabled={isAnyCheckboxChecked || isMoreThanOneChecked}
                disabledBtn2={!isAnyCheckboxChecked || isMoreThanOneChecked}
                buttonText2='Edit'
                onClickbtn2={handleEditStepper}
            /> */}

      <div className="card">
        <div className="card-body card-css p-1">
          <div className="row justify-content-end">
            <div className="col-md-12 col-sm-8">
              <div className="d-flex justify-content-end gap-3 ">
                {/* {editAddenda &&
                                    <button className="btn btn-light-red border-0 px-3 py-2" disabled={!isAnyCheckboxChecked || isMoreThanOneChecked || projectStatus} onClick={handleEditStepper}>Edit</button>
                                } */}
                {createAddenda && (
                  <button
                    className="btn btn-primary py-2"
                    disabled={
                      projectStatus
                    }
                    onClick={handleShowstepper}
                  >
                    +Add an Addendum
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <h5 className="mt-3 mb-3">Approved & Reviewed Addenda</h5>
        <div className="col-md-12">
          <div className="card card-css">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table datanew dataTable no-footer table-hover">
                  <thead>
                    <tr>
                      <th>
                        {/* <input
                          type="checkbox"
                          className="form-check-input cursor-pointer"
                          checked={isTableHeadChecked}
                          onChange={handleTableHeadChange}
                        /> */}
                      </th>
                      <th></th>
                      <th></th>
                      <th>NBR</th>
                      <th>TYPE</th>
                      <th>ADDENDUM DATE</th>
                      <th>WRITTEN BY</th>
                      <th>CONTRACT</th>
                      <th>TIME</th>
                      <th>STATUS</th>
                      <th className="text-end">SALE AMOUNT</th>
                      <th className="text-end">COST AMOUNT</th>
                      <th className="text-end">MARKUP</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{data?.result?.originalContract?.type}</td>
                      <td><DateComp formattedDate={data?.result?.originalContract ? data?.result?.originalContract.addendaDate : null} />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-end">
                        {/* ${
                          data?.result?.originalContract?.saleAmount !== null && data?.result?.originalContract?.saleAmount !== undefined && data?.result?.originalContract?.saleAmount !== 0 ? data?.result?.originalContract?.saleAmount.toFixed(2).toLocaleString() : '0.00'
                        } */}
                        <FormattedNumber value={data?.result?.originalContract?.saleAmount} />
                      </td>
                      <td className="text-end">
                        {/* $ {
                          data?.result?.originalContract?.costAmount !== null && data?.result?.originalContract?.costAmount !== undefined && data?.result?.originalContract?.costAmount !== 0 ? data?.result?.originalContract?.costAmount.toFixed(2).toLocaleString() : "0.00"
                        } */}
                        <FormattedNumber value={data?.result?.originalContract?.costAmount} />

                      </td>
                      <td className="text-end">
                        {
                          !Number.isNaN(OrignalContractMarkup) &&
                            OrignalContractMarkup !== Infinity
                            ? OrignalContractMarkup.toFixed(2).toLocaleString()
                            : "--"}
                      </td>
                      {/* <td className="text-center">{OrignalContractMarkup > 0 && !Number.isNaN(OrignalContractMarkup) && OrignalContractMarkup !== null && OrignalContractMarkup !== Infinity ? data?.result?.originalContract?.addendaMarkUp.toFixed(2).toLocaleString() : "--"}</td> */}
                      <td></td>
                    </tr>
                    {data?.result?.approvedAndReviewd?.map(
                      (data: any, index: any) => (
                        <tr
                          key={data?.id}
                          onClick={(e) => handleRowClicked(data)}
                        >
                          <td
                            className="cursor-pointer"
                            // onClick={() => handleShowAddenda(data)}
                            onClick={() => handlePrintWithData(data)}
                          >
                            {!isFetching ?
                              <button
                                className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                data-tooltip-id="my-tooltip-5">
                                <ImageWithBasePath
                                  src="assets/img/printIcon.svg"
                                  className=""
                                  alt="Logo"
                                  width={16}
                                  height={16}
                                />
                              </button>
                              :
                              <div className="spinnerPdf" />
                            }

                          </td>
                          <td>

                            {/* <input
                                                        type="checkbox"
                                                        className="form-check-input cursor-pointer"
                                                        checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.id)}
                                                        onChange={(e) => handleCheckItem(e, data)}
                                                    /> */}
                            {/* {editAddenda && (
                              <div
                                className="cursor-pointer"
                                onClick={() => handleEditStepper(data)}
                              >
                                {svgIcons.updateIcon}
                              </div>
                            )} */}
                            <button
                              className="cursor-pointer border-0 bg-transparent"
                              data-tooltip-id="my-tooltip-4"
                              onClick={() => handleViewAddenda(data)}
                            >
                              {svgIcons.eyeIcon}
                            </button>

                          </td>
                          <td>
                            {data?.status === 'Reviewed' &&
                              <button
                                data-tooltip-id="my-tooltip-1"
                                className="cursor-pointer border-0 bg-transparent"
                                onClick={() => handleApproveAddenda(data)}
                                disabled={permissionList[2]?.id === 41 && permissionList[2]?.haveaccess === false}
                              >
                                {svgIcons.checkIcon}
                              </button>
                            }
                          </td>
                          <td>{data?.addendaNbr}</td>
                          <td>{data?.type}</td>
                          <td>
                            <DateComp formattedDate={data?.addendaDate || ''} />
                          </td>
                          <td>{data?.writtenByName.trim() || ""}</td>
                          <td>
                            <input
                              type="checkbox"
                              className="form-check-input cursor-pointer"
                              checked={data?.contract}
                              disabled
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              className="form-check-input cursor-pointer"
                              checked={data?.timeline}
                              disabled
                            />
                          </td>
                          <td>
                            <span
                              className={`badge badge-pill badge-status ${data?.status === "Approved"
                                ? "bg-soft-success text-success"
                                : "bg-soft-warning text-warning"
                                }`}
                            >
                              {data.status}
                            </span>
                          </td>
                          <td className="text-end">
                            {/* ${data?.saleAmount ? data?.saleAmount.toFixed(2).toLocaleString() : '0.00'} */}
                            <FormattedNumber value={data?.saleAmount} />
                          </td>
                          <td className="text-end">
                            {/* ${data?.costAmount ? data?.costAmount.toFixed(2).toLocaleString() : '0.00'} */}
                            <FormattedNumber value={data?.costAmount} />
                          </td>
                          <td className="text-end">
                            {data?.addendaMarkUp && data?.addendaMarkUp > 0 && (data?.costAmount > 0 && data?.saleAmount > 0) ? data?.addendaMarkUp.toFixed(2).toLocaleString() : "--"}
                          </td>
                        </tr>
                      )
                    )}
                    {(isLoading || isLoadingEmail) &&
                      <TableLoading />
                    }
                  </tbody>
                  <tfoot>
                    <tr className="border-style-none">
                      <td colSpan={10} className="text-end color-red">
                        <strong>Addenda Totals:</strong>
                      </td>
                      <td className="color-red text-end">
                        <strong>
                          {/* ${totalAddendaApprSaleAmount !== 0 && totalAddendaApprSaleAmount !== null && totalAddendaApprSaleAmount !== undefined ? totalAddendaApprSaleAmount?.toFixed(2)?.toLocaleString() : "0.00"} */}
                          <FormattedNumber value={totalAddendaApprSaleAmount} />
                        </strong>
                      </td>
                      <td className="color-red text-end">
                        <strong>
                          {/* ${totalAddendaApprCostAmount !== 0 && totalAddendaApprCostAmount !== null && totalAddendaApprCostAmount !== undefined ? totalAddendaApprCostAmount?.toFixed(2)?.toLocaleString() : '0.00'} */}
                          <FormattedNumber value={totalAddendaApprCostAmount} />

                        </strong>
                      </td>
                      <td className="color-red text-end">
                        <strong>{totalMarkUpAppr && totalMarkUpAppr > 0 && (totalAddendaApprCostAmount > 0 && totalAddendaApprSaleAmount > 0) ? totalMarkUpAppr.toFixed(2).toLocaleString() : "--"}</strong>
                      </td>
                    </tr>
                    <tr className="border-style-none">
                      <td colSpan={10} className="text-end color-red">
                        <strong>Grand Totals:</strong>
                      </td>
                      <td className="color-red text-end">
                        <strong>
                          {/* ${totalGrandApprSaleAmount?.toFixed(2)?.toLocaleString()} */}
                          <FormattedNumber value={totalGrandApprSaleAmount} />
                        </strong>
                      </td>
                      <td className="color-red text-end">
                        <strong>
                          {/* ${totalGrandApprCostAmount?.toFixed(2).toLocaleString()} */}
                          <FormattedNumber value={totalGrandApprCostAmount} />
                        </strong>
                      </td>
                      <td className="color-red text-end">
                        <strong>{grandTotalMarkup !== Infinity && grandTotalMarkup !== null && grandTotalMarkup > 0 && (totalGrandApprCostAmount > 0 && totalGrandApprSaleAmount > 0) ? grandTotalMarkup.toFixed(2).toLocaleString() : "--"}</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div >
      <div className="row">
        <h5 className="mt-3 mb-3">Pending & Voided Addenda</h5>
        <div className="col-md-12">
          <div className="card card-css">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table datanew dataTable no-footer table-hover">
                  <thead>
                    <tr>
                      <th>
                        {/* <input
                          type="checkbox"
                          className="form-check-input cursor-pointer"
                          checked={isTableHeadCheckedPending}
                          onChange={handleTableHeadChangePending}
                        /> */}
                      </th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>NBR</th>
                      <th>TYPE</th>
                      <th>ADDENDUM DATE</th>
                      <th>WRITTEN BY</th>
                      <th>CONTRACT</th>
                      <th>TIME</th>
                      <th>STATUS</th>
                      <th className="text-end">SALE AMOUNT</th>
                      <th className="text-end">COST AMOUNT</th>
                      <th className="text-end">MARKUP</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.result?.pendingAndVoided?.map(
                      (data: any, index: any) => (
                        <tr key={data?.id}>
                          <td
                            className="cursor-pointer"
                            // onClick={() => handleShowAddenda(data)}
                            onClick={() => handlePrintWithData(data)}
                          >
                            {!isFetching ?
                              <button
                                className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                data-tooltip-id="my-tooltip-5">
                                <ImageWithBasePath
                                  src="assets/img/printIcon.svg"
                                  className=""
                                  alt="Logo"
                                  width={16}
                                  height={16}
                                />
                              </button>
                              :
                              <div className="spinnerPdf" />
                            }
                          </td>
                          <td>
                            <button
                              className="cursor-pointer bg-transparent border-0"
                              data-tooltip-id="my-tooltip-4"

                              onClick={() => handleViewAddenda(data)}
                            >
                              {svgIcons.eyeIcon}
                            </button>
                          </td>
                          <td>
                            {/* <input
                              type="checkbox"
                              className="form-check-input cursor-pointer"
                              onChange={(e) => handleCheckItemPending(e, data)}
                            /> */}
                            {data?.status !== 'Voided' ?
                              <>
                                {editAddenda && (
                                  <button
                                    data-tooltip-id="my-tooltip-3"
                                    className="cursor-pointer btn-transparent bg-transparent border-0"
                                    onClick={(e) => handleEditStepper(data)}
                                  >
                                    {svgIcons.updateIcon}
                                  </button>
                                )}
                              </>
                              : ""
                            }
                          </td>
                          <td>
                            {data?.status !== 'Voided' &&
                              <button
                                data-tooltip-id="my-tooltip-2"
                                className="cursor-pointer border-0 bg-transparent"
                                onClick={() => handleReviewAddenda(data)}
                                disabled={permissionList[1]?.id === 40 && permissionList[1]?.haveaccess === false}
                              >
                                {svgIcons.approvedIcon}
                              </button>
                            }
                          </td>


                          <td>{data?.addendaNbr}</td>
                          <td>{data?.type}</td>
                          <td>
                            <DateComp formattedDate={data?.addendaDate || ''} />
                          </td>
                          <td>{data?.writtenByName.trim() || ""}</td>
                          <td>
                            <input
                              type="checkbox"
                              className="form-check-input cursor-pointer"
                              checked={data?.contract}
                              disabled
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              className="form-check-input cursor-pointer"
                              checked={data?.timeline}
                              disabled
                            />
                          </td>
                          <td>
                            <span
                              className={`badge badge-pill badge-status ${data?.status === "Approved"
                                ? "bg-soft-success text-success"
                                : data?.status === "Voided"
                                  ? "bg-soft-danger text-danger"
                                  : data?.status === "Reviewed"
                                    ? "bg-soft-danger text-red"
                                    : "bg-soft-danger text-danger"
                                }`}
                            >
                              {data.status}
                            </span>
                          </td>
                          <td className="text-end">
                            {/* ${data?.saleAmount?.toFixed(2).toLocaleString()} */}
                            <FormattedNumber value={data?.saleAmount} />
                          </td>
                          <td className="text-end">
                            {/* ${data?.costAmount?.toFixed(2).toLocaleString()} */}
                            <FormattedNumber value={data?.costAmount} />
                          </td>
                          <td className="text-end">
                            {data?.addendaMarkUp && data?.addendaMarkUp > 0 && (data?.costAmount > 0 && data?.saleAmount > 0) ? data?.addendaMarkUp.toFixed(2).toLocaleString() : "--"}

                          </td>
                        </tr>
                      )
                    )}
                    {isLoading &&
                      <TableLoading />
                    }
                  </tbody>
                  <tfoot>
                    <tr className="border-style-none">
                      <td colSpan={11} className="text-end color-red">
                        <strong>Addenda Totals:</strong>
                      </td>
                      <td className="color-red text-end">
                        <strong>
                          {/* ${totalAddendaPendSaleAmount !== undefined && totalAddendaPendSaleAmount !== null ? totalAddendaPendSaleAmount.toFixed(2).toLocaleString() : '0.00'} */}
                          <FormattedNumber value={totalAddendaPendSaleAmount} />
                        </strong>
                      </td>
                      <td className="color-red text-end">
                        <strong>
                          {/* {totalAddendaPendCostAmount !== undefined && totalAddendaPendCostAmount !== null ? totalAddendaPendCostAmount.toFixed(2).toLocaleString() : '0.0'} */}
                          <FormattedNumber value={totalAddendaPendCostAmount} />
                        </strong>
                      </td>
                      <td className="color-red text-end">
                        <strong>{totalMarkUpPend !== 0 && totalMarkUpPend > 0 && (totalAddendaPendCostAmount > 0 && totalAddendaPendSaleAmount > 0) ? totalMarkUpPend?.toFixed(2).toLocaleString() : "--"}</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Addenda;
